<template>
  <div id="app">
    <div class="menu-box" v-if="screenWidth > 750">
      <div class="log-box">
        <img src="@/assets/logo.png" alt="">
        <span>ได้บาทง่ายๆ</span>
      </div>
      <div class="menu-item">
        <div @click="choiceMenu(0)" :class="(menuIndex === 0) ? 'choice' : ''">หน้าแรก</div>
        <div @click="choiceMenu(1)" :class="(menuIndex === 1) ? 'choice' : ''">ขั้นตอนการใช้งาน</div>
        <div @click="choiceMenu(2)" :class="(menuIndex === 2) ? 'choice' : ''">จุดเด่นของเรา</div>
        <div @click="choiceMenu(3)" :class="(menuIndex === 3) ? 'choice' : ''">นโยบายความเป็นส่วนตัว</div>
        <div @click="choiceMenu(4)" :class="(menuIndex === 4) ? 'choice' : ''"> ติดต่อเรา</div>
      </div>
    </div>
    <div class="home" id="home">
      <img src="@/assets/banner.png" class="banner">
      <div class="home-name-info-box">
        <div class="home-name">
          <p> ไม่มีหลักประกัน ดอกเบี้ยต่ำ สินเชื่อออนไลน์</p>
        </div>
      </div>
    </div>
    <div class="step-db-box" id="step">
      <div class="step-db-title">ขั้นตอนการใช้งาน</div>
      <div class="step-info-content">
        <div class="step-db-item-box-db">
          <div class="step-db-item">
            <img src="@/assets/step-1.png" alt="">
            <p>1. ดาวน์โหลดแอพพลิเคชันได้บาทง่ายๆ</p>
          </div>
          <div class="step-db-item">
            <img src="@/assets/step-3.png" alt="">
            <p>3. เลือกผลิตภัณฑ์สินเชื่อที่คุณชื่นชอบ</p>
          </div>
        </div>
        <div class="step-db-item-box-db">
          <img src="@/assets/index.png" alt="">
        </div>
        <div class="step-db-item-box-db">
          <div class="step-db-item">
            <img src="@/assets/step-2.png" alt="">
            <p>2. กรอกข้อมูลส่วนตัวให้ครบถ้วน</p>
          </div>
          <div class="step-db-item">
            <img src="@/assets/step-4.png" alt="">
            <p>4. ชำระเงินกู้อย่างตรงเวลา จะสามารถเพิ่มวงเงินกู้ครั้งต่อไปได้</p>
          </div>
        </div>
      </div>
    </div>

    <div class="product-db-box" id="product">
      <div class="step-db-title">จุดเด่นของเรา</div>
      <div class="product-db-content">
        <div class="product-db-img"><img src="@/assets/product.png"></div>
        <div class="product-db-info-db-box">
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">1</div>
            </div>
            <div class="text">เป็นผลิตภัณฑ์สินเชื่อที่คัดสรรมาอย่างดี</div>
          </div>
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">2</div>
            </div>
            <div class="text">สมัครผลิตภัณฑ์สินเชื่อได้หลายรายการเพียงแค่คลิกเดียว</div>
          </div>
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">3</div>
            </div>
            <div class="text">ตอบโจทย์ความต้องการต่างๆ ในชีวิตและการทำงาน</div>
          </div>
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">4</div>
            </div>
            <div class="text">ข้อมูลส่วนบุคคลจะเก็บเป็นความลับอย่างเข้มงวด</div>
          </div>

        </div>
      </div>
    </div>

    <div class="del-data-box">
      <div class="tel-box" v-if="steps == 1">
        <div class="tip">การใช้ฟังก์ชันการลบข้อมูลเพื่อความปลอดภัยของข้อมูลของคุณ คุณต้องยืนยันตัวตนของคุณ</div>
        <div class="title">กรุณากรอกหมายเลขโทรศัพท์มือถือของคุณ</div>
        <input v-model="mobile" type="text" class="tel-in" placeholder="กรุณากรอกหมายเลขโทรศัพท์">
        <input v-model="password" type="password" class="tel-pa" placeholder="กรุณากรอกรหัสผ่านสำหรับแอป">
        <div class="btn" @click="delSearch">ขั้นตอนถัดไป</div>
      </div>
      <div class="tel-box" v-else-if="steps == 2">
        <div class="กล่องข้อความ">
          เรียนผู้ใช้
          <br> สวัสดี! ขอบคุณมากครับที่เลือกใช้แอพ ได้บาทง่ายๆ
          <br> ก่อนที่จะสมัครลบบัญชี โปรดตรวจสอบให้แน่ใจว่าคำสั่งซื้อของคุณทั้งหมดได้รับการชำระแล้ว และไม่มีคำสั่งซื้อที่อยู่ระหว่างการตรวจสอบ โปรดทราบว่าเมื่อลบบัญชีแล้ว จะไม่สามารถกู้คืนข้อมูลได้ โปรดยืนยันอย่างรอบคอบก่อนใช้งาน แอพนี้ไม่รับผิดชอบต่อความสูญเสียใด ๆ ที่เกิดขึ้นต่อทรัพย์สินส่วนบุคคล
          <br> หากคุณยืนยันว่าต้องการลบข้อมูลของคุณ โปรดคลิกปุ่มด้านล่าง
        </div>
        <div class="btn" @click="candelete">ยืนยันการลบ</div>
      </div>

      <div class="tel-box" v-else-if="steps == 3">
        <div class="title">โปรดป้อนรหัสยืนยันเพื่อยืนยันตัวตนของคุณ</div>
        <div class="iump-box">
          <input v-model="code" type="text" class="car-in tel-in" placeholder="กรุณากรอกรหัสยืนยัน 4 หลัก" />
          <div class="count-btn" @click="Reenviar"> {{ Time > 0 ? Time : 'ส่งอีกครั้ง' }} </div>
        </div>
        <div class="btn" @click="doDelete">ตกลง</div>
      </div>

      <div class="tel-box del-box" v-else-if="steps == 4">
        <img src="../assets/del.png" alt="">
        <p>ข้อมูลของคุณถูกลบแล้ว!</p>
      </div>
      <div class="tel-box" v-else-if="steps == 5">
        <div class="title">การยืนยันบัตรประจำตัวประชาชน</div>
        <input v-model="idcard" type="text" class="tel-in" placeholder="กรุณากรอกบัตรประจำตัวประชาชนของคุณ">
        <div class="btn" @click="verifyIdCard">กำลังตรวจสอบ</div>
      </div>
    </div>

    <div class="privacy-box" id='privacy' ref="privacy">
      <div class="content" :class="(isMore) ? '' : 'display'">
        <privacy></privacy>
      </div>
      <div class="get-more" @click="isMore = true" v-if="!isMore">
        <img src="@/assets/open.png">
      </div>
    </div>
    <div class="footer-db-box" id="footer">
      <div class="step-db-title">ติดต่อเรา</div>
      <div class="footer-dbcontent">
        <div class="text">ได้บาทง่ายๆ เป็นผู้ให้บริการสินเชื่อส่วนบุคคลชั้นนำ มุ่งมั่นที่จะให้บริการสินเชื่อออนไลน์ที่ไม่มีหลักประกัน มีประสิทธิภาพสูง และดอกเบี้ยต่ำแก่ผู้กู้ยืม ทางเราสามารถให้ผลิตภัณฑ์สินเชื่อมูลค่าสูงถึง 20,000 บาท ที่สำคัญใช้เพียงบัตรประจำตัวประชาชนใบเดียวก็สามารถลงทะเบียนสินเชื่อ รวมถึงกระทำกระบวนการทั้งหมดไม่ว่าจะเป็นการกู้ยืมหรือการชำระคืนเงินกู้ ในเวลาเดียวกัน ข้อมูลส่วนบุคคลของผู้ใช้งานจะได้รับการป้องกันอย่างเข้มงวดที่สุดจากทางเรา และจะทำให้ผู้ใช้งานได้รับประสบการณ์การกู้ยืมที่ดีที่สุด</div>
        <div class="footer-db-info">
          <div class="mail-db-box">
            <img src="@/assets/mail.png" class="mail-img">
            <div class="mail">hdoqwhioh34d@gmail.com</div>
          </div>
          <div class="address-db-box">
            <img src="@/assets/address.png" class="address-img">
            <div class="address">
              3445 อาคารเอ็นมาร์คพลาซ่า ถนนลาดพร้าว แขวงคลองจั่น เขตบางกะปิ กรุงเทพมหานคร 10240
            </div>
          </div>
        </div>
        <div class="bottom-text">
          Copyright 2024. ได้บาทง่ายๆ all Rights Reserved.
        </div>
      </div>
    </div>
    <div class="flex-box" v-if="msgDlg">
      <div class="msg-box">
        <div class="msg">
          <img src="../assets/title-err.png" class="err-img">
          {{ msg }}
        </div>
        <img src="../assets/close.png" class="close" @click="msgDlg = false">
      </div>
    </div>
  </div>
</template>

<script>
import privacy from "@/components/privacy";
import * as api from "@/api/api";
export default {
  name: 'App',
  components: {
    privacy
  },
  data() {
    return {
      isMore: false,
      menuIndex: 0,
      screenWidth: document.body.clientWidth,
      showMenu: false,
      mobile: '',
      password: '',
      code: '',
      msgDlg: false,
      msg: '',
      steps: 1,
      infoData: {},
      Time: 0,
      idcard: '',
      verifyIDCard: '',
    }
  },
  mounted() {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    choiceMenu(index) {
      this.menuIndex = index
      setTimeout(() => {
        this.showMenu = false
      }, 100);
      switch (index) {
        case 0: document.getElementById("home").scrollIntoView(); break;
        case 1: document.getElementById("step").scrollIntoView(); break;
        case 2: document.getElementById("product").scrollIntoView(); break;
        // case 3: document.getElementById("user").scrollIntoView(); break;
        // case 4: document.getElementById("about").scrollIntoView(); break;
        case 3: document.getElementById("privacy").scrollIntoView(); break;
        case 4: document.getElementById("footer").scrollIntoView(); break;
        default:
          break;
      }
    },
    menuClick() {
      this.showMenu = !this.showMenu
    },
    delSearch() {
      let data = {
        mobile: this.mobile,
        password: this.password
      }
      if (!this.mobile) {
        this.msg = 'หมายเลขโทรศัพท์มือถือต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }
      if (!this.password) {
        this.msg = 'รหัสผ่านต้องไม่เว้นว่าง'
        this.msgDlg = true
        return
      }

      let loding = this.$loading.show({})
      api.delInfoSearch(data).then(res => {
        loding.hide()
        this.infoData = res.data
        this.steps = 2
      }).catch(e => {
        loding.hide()
        this.msg = e.message
        this.msgDlg = true
      })
    },
    candelete() {
      let data = {
        user_id: this.infoData.user_id
      }
      let loding = this.$loading.show({})
      api.delInfoCanDelete(data).then(res => {
        loding.hide()
        if (res.data.idcard) {
          this.verifyIDCard = res.data.idcard
          this.steps = 5
        } else {
          this.steps = 3
          this.Reenviar()
        }
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    verifyIdCard() {
      console.log(this.verifyIDCard);
      if (this.verifyIDCard == this.idcard) {
        this.steps = 3
        this.Reenviar()
      } else {
        this.msgDlg = true
        this.msg = 'ป้อนบัตรประจำตัวไม่ถูกต้องและการตรวจสอบล้มเหลว'
      }
    },
    Reenviar() {
      if (this.Time > 0) {
        return
      }
      this.Countdown(60)
      let data = {
        mobile: this.mobile
      }
      let loding = this.$loading.show({})
      api.delInfoSms(data).then(res => {
        loding.hide()
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    doDelete() {
      let loding = this.$loading.show({})
      let data = {
        mobile: this.mobile,
        code: this.code,
        user_id: this.infoData.user_id
      }
      api.delInfoDoDelete(data).then(res => {
        loding.hide()
        this.steps = 4
      }).catch(e => {
        loding.hide()
        this.msgDlg = true
        this.msg = e.message
      })
    },
    Countdown(time) {
      this.Time = time
      if (time <= 0) {
        return
      }

      setTimeout(() => {
        this.Countdown(time - 1)
      }, 1000);
    }
  }
}
</script>


<style lang="less" >
@import url('@/style/m_index.less') only screen and (max-width: 750px);
@import url('@/style/pc_index.less') only screen and (min-width: 750px);
</style>
